import { useSelector } from "react-redux"
import { useQuery } from "@tanstack/react-query"

import { API_M2M_URL, TRANSACTION_STATUS_POLL_INTERVAL } from "../constants"
import { IGetSbpOutcomeTransferRequestStatusResponse, } from "../interface"
import { RootState } from "../../store/store"
import { checkIsFailure } from "../utils/utils"
import { axios } from "../axios"

export async function get(
  token: string | null,
  outcomeTransferRequestId: string | undefined,
) {
  const response = await axios(`${API_M2M_URL}/${outcomeTransferRequestId}`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  if (checkIsFailure(response.status)) {
    throw new Error("Ошибка загрузки данных")
  }
  return response.data
}

export const useGetSbpOutcomeTransferRequestStatus = (
  outcomeTransferRequestId: string | undefined,
  enabled: boolean,
) => {
  const token = useSelector((state: RootState) => state.auth.token)

  return useQuery<IGetSbpOutcomeTransferRequestStatusResponse>({
    queryKey: ["sbp-outcome-transfer-request-status", outcomeTransferRequestId],
    queryFn: () => get(token, outcomeTransferRequestId),
    refetchInterval: TRANSACTION_STATUS_POLL_INTERVAL,
    enabled,
  })
}
